import React, { useState, useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, Box, Button, IconButton } from '@material-ui/core';
import Checkbox from '../checkbox'
import { Link, useHistory } from "react-router-dom";
import { baseApiUrl } from '../dataProvider/sails';
import Typography from '@material-ui/core/Typography';
import HeaderSortable from '../common/header-sortable';
import { useTranslate } from 'react-admin';
import bin from '../assets/icons/primary-blue-bin.png';
import { useLocation } from "react-router-dom";
import { getDayMonthYear } from '../utils'
import moment from 'moment';
import { StyledButton } from '../common/table';
import { Clear, DeleteOutline } from '@material-ui/icons';
const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor:theme.palette.primary.main,
        borderBottom: 'solid 5px ' + theme.palette.background.default,
        fontWeight: 'inherit'
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 600,
    },
    tableCell: {
        borderBottom: 'solid 5px ' + theme.palette.background.default,
        // paddingTop: 0,
        // paddingBottom: 0
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
        color: 'white'
    },
    tableSortLabel: {
        fontFamily: 'UniviaPro',
        fontSize: ' 13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: ' 0.13px',
        color: '#ffffff',
        '&:hover': {
            color: '#ffffff'
        },
        '&:focus': {
            color: '#ffffff'
        },
    },
    textTableName: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#237fc2',
        textDecoration: 'none'
    },
    textTable: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#4f5064',
    },
    textTableLarge: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#4f5064',
        width: 190,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    },
    textTableMedium: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#4f5064',
        width: 100,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    },
    textPublish: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: 'green',
    },
    textPublishNo: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: 'red',
    },
    textTableNoData: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#4f5064',
        textAlign: 'center',
        padding: '30px'
    },
    borderCluster: {
        borderRadius: '10px',
        border: 'solid 1px #e0f0f2',
        backgroundColor: ' #fafefe',
    },
    textCluster: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: ' 0.36px',
        color: '#6cb5b8',
        textAlign: 'center',
        padding: '8px',
    },
    textEdit: {
        fontFamily: 'UniviaPro',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#ffffff',
    },
    borderDelete: {
        borderRadius: '12px',
        backgroundColor: '#e5f1f8',
    }
}));

const headCells = [
    { id: 'checkmark', numeric: false, disablePadding: false, label: '' },
    { id: 'image', numeric: false, disablePadding: false, label: 'Image' },
    { id: 'name', numeric: false, disablePadding: true, sorting: true, label: 'Name' },
    { id: 'type', numeric: false, disablePadding: false, sorting: true, label: 'Type' },
    { id: 'categories', numeric: false, disablePadding: false, label: 'Categories' },
    { id: 'description', numeric: false, disablePadding: false, label: 'Description' },
    { id: 'size', numeric: false, disablePadding: false, sorting: true, label: 'Length/size' },
    { id: 'owner', numeric: false, disablePadding: false, sorting: true, label: 'Created' },
];

function EnhancedTableHead(props) {
    const { classes, order, setOrder, handleCheckMark, data, checked, hidden } = props;

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <StyledTableCell
                        className={classes.tableSortLabel}
                        key={'cell-' + headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                    >
                        {
                            headCell.label !== '' ?
                                (
                                    headCell.label === 'Image' || headCell.label === 'Categories' || headCell.label === 'Length/size' || headCell.label === 'Uploaded by' ?
                                        headCell.label : <HeaderSortable
                                            title={headCell.label}
                                            field={headCell.id}
                                            order={order}
                                            setOrder={setOrder}
                                        />
                                )
                                :
                                headCell.id === 'checkmark' ?
                                    <Box hidden={hidden}>
                                        <Checkbox checked={checked.length === data.length} color='primary' onChange={(event) => handleCheckMark(event, -1, true)} />
                                    </Box> :
                                    <Box />

                        }
                    </StyledTableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

function MoviesTable({ data, getList, setSort, sort, buttonHidden, total, onDelete, checked, onClear, handleCheckMark }) {
    const classes = useStyles();
    const translate = useTranslate();
    const location = useLocation();
    const history = useHistory()

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [order, setOrder] = useState(sort || { field: 'name', order: 'DESC' });
    const [anchorEl, setAnchorEl] = useState(null);
    const [openPoper, setOpenPopper] = useState(false);
    const [openedit, setOpenEdit] = useState(false);

    const handleChangePage = (event, newPage) => {
        const pagination = { page: newPage + 1, perPage: rowsPerPage };
        getList(order, pagination);
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(event.target.value);
        setPage(0);
        const pagination = { page: 1, perPage: event.target.value };
        getList(order, pagination);
    };

    const handleRequestSort = (nextSort) => {
        setPage(0);
        setOrder(nextSort);
        if (setSort)
            setSort(nextSort);
        const pagination = { page: 1, perPage: rowsPerPage };
        getList(nextSort, pagination);
    };

    const stringCategory = (categories) => {
        var categoryStr = ""
        categories.forEach((item, index) => {
            if (item.category && item.category?.name) {
                if (index === 0)
                    categoryStr += item.category?.name
                else
                    categoryStr += `,${item.category?.name}`
            }
        })
        return categoryStr
    }

    return (

        // error > 0 ?
        <Paper className={classes.root}>
            <TableContainer className={classes.container}>
                <Table aria-label="sticky table">
                    {
                        checked.length > 0 ? (
                            <TableHead style={{ maxHeight: 70 }}>
                                <TableRow style={{ maxHeight: 70 }}>
                                    <TableCell style={{ backgroundColor: '#56657f', padding: '17px' }}>
                                        <Checkbox checked={checked.length === data.length} color='primary' onChange={(event) => handleCheckMark(event, -1, true)} />
                                    </TableCell>
                                    <TableCell style={{ backgroundColor: '#56657f', padding: '16px', height: '14%' }}>
                                        <StyledButton
                                            onClick={onDelete}
                                            variant='text'
                                            startIcon={<DeleteOutline />}
                                            style={{ left: -50, width: 68 }}
                                        >{translate(`pos.common.delete`)}</StyledButton>
                                    </TableCell>
                                    <TableCell style={{ backgroundColor: '#56657f', padding: '16px' }}></TableCell>
                                    <TableCell style={{ backgroundColor: '#56657f', padding: '16px' }}></TableCell>
                                    <TableCell style={{ backgroundColor: '#56657f', padding: '16px' }}></TableCell>
                                    <TableCell style={{ backgroundColor: '#56657f', padding: '16px' }}></TableCell>
                                    <TableCell style={{ backgroundColor: '#56657f', padding: '16px' }}></TableCell>
                                    <TableCell style={{ backgroundColor: '#56657f', padding: '8px 0' }} align='right'>
                                        <StyledButton
                                            onClick={onClear}
                                            variant='text'
                                            startIcon={<Clear />}
                                        >{checked.length} {checked.length > 1 ? translate('pos.categories.filesSelected') : translate('pos.categories.fileSelected')}</StyledButton>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                        ) :
                            < EnhancedTableHead checked={checked} data={data} handleCheckMark={handleCheckMark} classes={classes} order={order} setOrder={handleRequestSort} hidden={buttonHidden} />
                    }
                    <TableBody>
                        {
                            data.map((item, index) => (
                                buttonHidden ? <TableRow key={'table-row-' + index} hover tabIndex={-2} style={{ cursor: 'pointer' }}>
                                    <TableCell key={index + '-0'} style={{ width: 60 }} className={classes.tableCell} />
                                    <TableCell key={index + '-1'} style={{ width: 100 }} className={classes.tableCell}>
                                        <Box width={60} height={40}>
                                            <img src={baseApiUrl + '/media/' + item.image} style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'contain'
                                            }} />
                                        </Box>

                                    </TableCell>
                                    <TableCell key={index + '-2'} style={{ width: 100 }} className={classes.tableCell}>{item.name}</TableCell>
                                    <TableCell key={index + '-3'} style={{ width: 100 }} className={classes.tableCell}><Typography className={classes.textTable}>{item.type}</Typography></TableCell>
                                    <TableCell key={index + '-4'} style={{ width: 159 }} className={classes.tableCell}>
                                        <Typography className={classes.textTableLarge}>
                                            {stringCategory(item.categories)}
                                        </Typography>
                                    </TableCell>
                                    <TableCell key={index + '-5'} className={classes.tableCell} style={{ width: 129, textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', maxWidth: '129px' }}>{item.description}</TableCell>
                                    <TableCell key={index + '-6'} style={{ width: 120 }} className={classes.tableCell}><Typography className={classes.textTable}>{item.isVOD ? 'N/A' : (
                                        item.size / 1024 < 1000 ? (item.size / 1000).toFixed(0) + ' Kb' :
                                            item.size / 1024 / 1024 < 1000 ? (item.size / 1024 / 1024).toFixed(0) + ' Mb' :
                                                (item.size / 1024 / 1024 / 1024).toFixed(2) + ' Gb'
                                    )}</Typography></TableCell>
                                    <TableCell key={index + '-7'} className={classes.tableCell}>
                                        {`${moment(new Date(item.createdAt)).format('YYYY-MM-DD')}`}
                                    </TableCell>
                                </TableRow> :
                                    <TableRow key={'table-row-' + index} hover tabIndex={-2} style={{ cursor: 'pointer' }} onClick={() => { history.push("/media/" + item.id) }}>
                                        <TableCell key={index + '-0'} style={{ width: 60 }} className={classes.tableCell}><Checkbox onClick={(e) => { e.stopPropagation() }} checked={item.checked ? true : false} onChange={(event) => handleCheckMark(event, index)} color='primary' /></TableCell>
                                        <TableCell key={index + '-1'} style={{ width: 100 }} className={classes.tableCell}>
                                            <Box width={60} height={40}>
                                                <img src={baseApiUrl + '/media/' + item.image} style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain'
                                                }} />
                                            </Box>

                                        </TableCell>
                                        <TableCell key={index + '-2'} style={{ width: 100 }} className={classes.tableCell}>{item.name}</TableCell>
                                        <TableCell key={index + '-3'} style={{ width: 100 }} className={classes.tableCell}><Typography className={classes.textTable}>{item.type}</Typography></TableCell>
                                        <TableCell key={index + '-4'} style={{ width: 159 }} className={classes.tableCell}>
                                            <Typography className={classes.textTableLarge}>
                                                {stringCategory(item.categories)}
                                            </Typography>
                                        </TableCell>
                                        <TableCell key={index + '-5'} className={classes.tableCell} style={{width: 129, textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', maxWidth: '129px' }}>{item.description}</TableCell>
                                        <TableCell key={index + '-6'} style={{ width: 120 }} className={classes.tableCell}><Typography className={classes.textTable}>{item.isVOD ? 'N/A' : (
                                            item.size / 1024 < 1000 ? (item.size / 1000).toFixed(0) + ' Kb' :
                                                item.size / 1024 / 1024 < 1000 ? (item.size / 1024 / 1024).toFixed(0) + ' Mb' :
                                                    (item.size / 1024 / 1024 / 1024).toFixed(2) + ' Gb'
                                        )}</Typography></TableCell>
                                        <TableCell key={index + '-7'} className={classes.tableCell}>
                                            <Typography className={classes.textTableMedium}>
                                                {`${moment(new Date(item.createdAt)).format('YYYY-MM-DD')}`}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                            ))
                        }

                    </TableBody>
                </Table>
            </TableContainer>


            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={total}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </Paper>
        //  :<Typography className={classes.textTableNoData}>{translate(`pos.user.error.datanotfound`)} </Typography>
    );
}

export default MoviesTable;
